import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppRemixIcon } from '@/layout/AppComponents';
import AppLink from '../../../../routing/helpers/AppLink';

export default function Breadcrumb() {
  const { moduleBridgeHex } = useParams();
  const breadcrumb = useSelector((state) => state.currentPage?.breadcrumb);

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li
          className={`breadcrumb-item${
            breadcrumb?.length === 0 ? ' active' : ''
          }`}
          title="Inicio"
        >
          {breadcrumb?.length === 0 ? (
            <AppRemixIcon icon="home" className="mr-1" />
          ) : (
            <AppLink
              path="user_module_documentManager_item_list"
              params={{
                moduleBridgeHex,
                parentItemHex: '0',
                page: 1,
                filtersHex: '0',
              }}
            >
              <AppRemixIcon icon="home" className="mr-1" />
            </AppLink>
          )}
        </li>
        {breadcrumb?.map((b, i) => (
          <li
            className={`breadcrumb-item${
              i === breadcrumb?.length - 1 ? ' active' : ''
            }`}
          >
            <AppLink
              path="user_module_documentManager_item_list"
              params={{
                moduleBridgeHex,
                parentItemHex: b?.hex,
                page: 1,
                filtersHex: '0',
              }}
            >
              {b?.title || '...'}
            </AppLink>
          </li>
        ))}
      </ol>
    </nav>
  );
}
